import { InstanceScreen } from 'component/navigation/instance';

export default function AdminUsersScreen() {
    return <InstanceScreen screenKey='adminUsers' />;
}
